import styles from './sociogram-surveys-list.module.scss'
import { useTranslation } from 'react-i18next'
import AlertComponent from '@BUP/components/Generics/Alert'
import CollapsePanel from '..'
import SociogramTable from '@BUP/components/Generics/Table/SociogramTable'
import { useGetSociogram } from '@BUP/hooks/Sociogram/useGetSociogram'
import { useGetSurveysBySociogramId } from '@BUP/hooks/Sociogram/useGetSurveysBySociogramId'
import { useGetOrganizationRecommendations } from '@BUP/hooks/Sociogram/recommendations/useGetOrganizationRecommendations'
import FinishSociogramModal from './finish-sociogram-modal'
import ButtonComponent from '../../Button'
import { ReloadOutlined } from '@ant-design/icons'
import { useGetParticipantsTerminatedsBySociogram } from '@BUP/hooks/Sociogram/participantsTerminated/useGetParticipantsTerminatedBySociogram'
import { useGetSociogramTeachers } from '@BUP/hooks/Sociogram/teachersData/useGetSociogramTeachers'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'
import { useContext } from 'react'

const SociogramSurveysList = ({ sociogramId, arraySociogramsIds }) => {
  const i18n = useTranslation()
  const { isLoadingSociogram, dataSociogram, getSociogram, errorSociogram, isFetchingSociogram } =
  useGetSociogram(sociogramId)

  const term = useContext(CurrentTermContext)

  const { dataSociogramTeachers, isLoadingSociogramTeachers, isFetchingSociogramTeachers } = useGetSociogramTeachers(term.id)

  const { data: surveysData, isLoading: isLoadingDataSurveys, error: errorDataSurveys, refetch: getSurveys, isFetching: isFetchingSurveys } =
  useGetSurveysBySociogramId(sociogramId)

  const { participantsTerminated, isLoadingParticipantsTerminated } = useGetParticipantsTerminatedsBySociogram(sociogramId)

  const { isLoadingRecommendations, isFetchingRecommendations, dataRecommendations, errorResultRecommendations } = useGetOrganizationRecommendations()

  const reloadSurveys = async () => {
    await getSurveys()
  }

  const reloadSociogram = async () => {
    await getSociogram()
  }

  if (errorSociogram || !dataSociogram || dataSociogram.length === 0) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSociogram')}
          type='error'
        />

        <ButtonComponent buttonText={i18n.t('common.resources.generic.actions.reload.generic')} size='small' icon={<ReloadOutlined />} onClick={reloadSociogram} />
      </div>
    )
  }

  if (errorDataSurveys || !surveysData || surveysData.length === 0) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSurveys')}
          type='error'
        />
        <ButtonComponent buttonText={i18n.t('common.resources.generic.actions.reload.surveys')} size='small' icon={<ReloadOutlined />} onClick={reloadSurveys} />
      </div>
    )
  }

  const combinedDataSurveys = surveysData.map(survey => {
    const result = dataRecommendations?.find(result => result.resultId === survey.results[0]?.id)

    const surveyCourseId = survey.courses?.[0]?.id

    const teacherData = dataSociogramTeachers?.teachers?.find(teacher =>
      teacher.courses?.some(c => c.id === surveyCourseId)
    ) ?? null

    const participantsTerminatedSurvey = participantsTerminated.find(elem => elem.surveyId === survey.id)?.participantsTerminated || []

    return {
      ...survey,
      resource: result || null,
      participantsTerminated: participantsTerminatedSurvey,
      teacherData
    }
  })

  const sociogram = dataSociogram[0]
  const { isDone: isDoneSociogram } = sociogram

  return (
    <div
      className={styles.surveys_container}
      data-test='surveys-list-container'
    >
      <div className={styles.collapse_wrapper}>
        <CollapsePanel
          id={sociogramId}
          label={
            <h5 className={styles.collapse_label}>{i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.collapseTitle')}</h5>
            }
          shadow
          borderBottom
          isOpenCollapse
        >
          <div
            className={styles.table_wrapper}
            data-test='surveys-list-table-wrapper'
          >
            <SociogramTable
              sociogram={sociogram}
              error={errorSociogram}
              loading={isLoadingSociogram || isFetchingSociogram || isLoadingDataSurveys || isFetchingSurveys || isLoadingRecommendations || isLoadingSociogramTeachers || isFetchingSociogramTeachers || isFetchingRecommendations || isLoadingParticipantsTerminated}
              surveysData={combinedDataSurveys}
              errorResultRecommendations={errorResultRecommendations}
            />
          </div>
        </CollapsePanel>
      </div>
      <FinishSociogramModal
        sociogramId={sociogramId}
        isDoneSociogram={isDoneSociogram}
        getSociogram={getSociogram}
        arraySociogramsIds={arraySociogramsIds}
      />
    </div>
  )
}

export default SociogramSurveysList
